import AppTypography from 'src/components/elements/typography/AppTypography'
import {useCurrentLocale} from 'src/hooks/locale'
import {LOCALE_FR} from 'src/constants/locale'
import CustomIconSvg, {
  CustomIconSvgType,
} from 'src/components/elements/icons/svgs/CustomIconSvg'

const advantagesFr: {
  title: string
  description: string
  icon: CustomIconSvgType
}[] = [
  {
    title: 'Annulation gratuite sous 24 heures',
    description: "Remboursement intégral si vous changez d'avis",
    icon: 'calendar-check',
  },
  {
    title: 'Vérifié par MonsieurChalets',
    description: 'Cette propriété a été vérifiée par MonsieurChalets',
    icon: 'diamond',
  },
  {
    title: 'Majordome disponible',
    description: 'Bonification de séjour disponible sur cette propriété',
    icon: 'plane',
  },
  /* {
    title: 'Entreprise 100% québécoise',
    description: "Encourageons l'économie locale",
    icon: 'flash',
  },*/
]

const advantagesEn: {
  title: string
  description: string
  icon: CustomIconSvgType
}[] = [
  {
    title: 'Free cancellation within 24 hours',
    description: 'Full refund if you change your mind',
    icon: 'calendar-check',
  },
  {
    title: 'Verified by MonsieurChalets',
    description: 'This property has been verified by MonsieurChalets',
    icon: 'diamond',
  },
  {
    title: 'Stay enhancement available',
    description: 'Majordome available for this property',
    icon: 'plane',
  },
  /*  {
    title: '100% Canadian company',
    description: "Let's support local economy",
    icon: 'flash',
  },*/
]

export default function MCAdvantages() {
  const currentLocale = useCurrentLocale()
  const advantages = currentLocale === LOCALE_FR ? advantagesFr : advantagesEn

  return (
    <div className="grid grid-cols-1 gap-2">
      {advantages.map((advantage, index) => {
        return (
          <div
            key={index}
            className="flex flex-row justify-start items-center gap-4 border border-gray-200 rounded-xl px-3 py-2"
          >
            <CustomIconSvg
              icon={advantage.icon}
              className="text-gray-600 min-w-6 w-6 h-6"
            />
            <div className="flex flex-col justify-start items-start">
              <AppTypography variant="displayXSmall" className="text-gray-600">
                {advantage.title}
              </AppTypography>
              <AppTypography
                variant="caption"
                neutralColor={400}
                className="mt-0.5 leading-snug"
              >
                {advantage.description}
              </AppTypography>
            </div>
          </div>
        )
      })}
    </div>
  )
}
